import { gsap, Power4 } from 'gsap'
import Swiper from 'swiper'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { FreeMode, Navigation } from 'swiper/modules'
import { elementsToMaxHeight } from '../utils/elementsToMaxSizes'
import Lottie from 'lottie-web'

gsap.registerPlugin(ScrollTrigger)

const $body = $('body')

let swiper = new Swiper('.swiper-all-why-us', {
  modules: [FreeMode, Navigation],
  spaceBetween: 8,
  slidesPerView: 'auto',
  freeMode: {
    enabled: true
  },
  loop: false,
  speed: 1000,
  // autoplay: {
  //     delay: 3500
  // },
  breakpoints: {
    1024: {
      spaceBetween: 16
    }
  },
  navigation: {
    nextEl: '.swiper-all-why-us-navigation .slide-next',
    prevEl: '.swiper-all-why-us-navigation .slide-prev'
  }
})

export function setupWhyUsLottie() {
  let whyUsIcons = $('.why-us-lottie-icon');

  if (!whyUsIcons.length) {
    return false;
  }

  let animations = [];

  whyUsIcons.each(function () {
    let path = $(this).data('src');

    let animation = Lottie.loadAnimation({
      container: this,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: path,
    });

    animation.addEventListener('DOMLoaded', () => {
      animation.play();
      animation.addEventListener('complete', () => {
        animation.goToAndStop(animation.totalFrames, true);
      });
    });

    animations.push(animation);
  });

  $body.on('mouseenter', '.why-us-card', function () {
    let id = $(this).data('id');
    if (animations[id]) {
      animations[id].goToAndPlay(0);
    }
  });

  ScrollTrigger.create({
    trigger: '.block-all-why-us',
    start: 'top bottom-=10%',
    end: 'center center',
    scrub: true,
    once: true,
    onEnter: () => {
      animations.forEach(animation => {
        animation.goToAndPlay(0);
      });
    }
  });
}

// setupWhyUsLottie();

$(window).on('load', function () {
  elementsToMaxHeight($('.why-us-card-content'))

  let $allWhyUsSlider = $('.block-all-why-us')
  if($allWhyUsSlider.length) {

    gsap.set('.why-us-card', { x: '10vw' })

    ScrollTrigger.create({
      trigger: '.block-all-why-us',
      start: 'top bottom-=10%',
      end: 'center center',
      scrub: true,
      //markers: true,
      once: true,
      onEnter: () => {
        gsap.to('.why-us-card', {x: 0, delay: 0.1, duration: 0.60, stagger: 0.10, ease: Power4.easeOut})
      }
    })
  }
})
